<template>
  <div>
    <AtomicUiDropdown
      :model-value="dropdownValue"
      name="sort-by"
      label="Sort By"
      :options="filteringFacetsStore.getSortBy.sortByOptions"
      @update:model-value="dropdownUpdate"
    />
  </div>
</template>

<script setup>
const filteringFacetsStore = useFilteringFacetsStore();
const { isMobile } = useDisplay();
const { updateSortBy, selections } = useSortFilter();

const dropdownValue = computed(() => {
  if (isMobile.value) {
    return selections.value.sortBySelectedValue;
  }
  return filteringFacetsStore.getSortBy.selectedValue;
});

const dropdownUpdate = (selected) => {
  if (isMobile.value) {
    updateSortBy(selected);
  } else {
    filteringFacetsStore.updateSortBySelected(selected);
    filteringFacetsStore.getAllSelectedCriteria();
  }
};
</script>

<style lang="scss" scoped>
:deep(.select-container) {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
